<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12"></div>
            <!-- ngFor for para percorrer o array de erros e se existir erros imprimir na tela -->
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
                {{ erro }}
            </div>
        </div>
        <div class="mat-elevation-z8">    
            <mat-card>    
                <mat-card-title>
                    <mat-icon>color_lens</mat-icon>
                    Caixa
                </mat-card-title>
                <mat-tab-group mat-align-tabs="start" #tabGroup>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>add</mat-icon>
                            Lançamentos
                        </ng-template>
                        <!-- CADASATRANDO OBJETO INICIO -->
                        <mat-card>
                            <form [formGroup]="formulario" (ngSubmit)="submit()">
                                <div class="row">
                                    <div class="col-1">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>ID</mat-label>
                                            <input formControlName="id" matInput readonly>
                                        </mat-form-field>
                                    </div>  
                                    <div class="col-2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Nome</mat-label>
                                            <input formControlName="name" matInput placeholder="Digite seu nome" minlength="3"
                                                maxlength="50" required>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Saldo Pix</mat-label>
                                            <span matPrefix>R$ &nbsp;</span>
                                            <input matInput formControlName="pixBalance" mask="separator.2" thousandSeparator="."
                                                placeholder="1.000,00" minlength="1" maxlength="6" required>
                                           
                                        </mat-form-field>
                                    </div>
                                    <div class="col-2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Saldo Caixa</mat-label>
                                            <span matPrefix>R$ &nbsp;</span>                                           
                                            <input matInput formControlName="caixaBalance"
                                                currencyMask  [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" required>                                             
                                        </mat-form-field>
                                    </div>
                                    <div class="col-2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Saldo Cartão</mat-label>
                                            <span matPrefix>R$ &nbsp;</span>
                                            <input matInput formControlName="cartaoBalance" mask="separator.2" thousandSeparator="."
                                                placeholder="1.000,00" minlength="1" maxlength="6" required>
                                        </mat-form-field>
                                    </div>

                                    <div class="col2">
                                        <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                            <mat-label>Situação do caixa</mat-label>
                                            <mat-select formControlName="active" required>
                                                <mat-option value="true">Ativo</mat-option>
                                                <mat-option value="false">Inativo</mat-option>
                                            </mat-select>
                                            
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row justify-content-between">
                                    <div class="col-6">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button (click)="limparFormulario()" mat-raised-button>
                                            <mat-icon>insert_drive_file</mat-icon>
                                            Limpar
                                        </button>
                                    </div>
                                    <div class="col-6" align="right">
                                        <!-- habilita desabilita botão com o forma validate -->
                                        <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                                            <mat-icon>save</mat-icon>
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div class="esp-top">
                                <!-- verifica se tem erros no preenchimento do campo e se inicio o preenchimento -->
                                <div *ngIf="formulario.controls.name.errors && !formulario.controls.name.pristine"
                                    class="alert alert-warning" role="alert">
                                    Campo nome deve conter entre 3 e 50 caracteres!
                                </div>
                        
                            </div>
                        </mat-card>
                    </mat-tab>
                    <!-- CADASATRANDO OBJETO INICIO -->

                    <!-- LISTANDO TODAS INICIO -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>list</mat-icon>
                            Listar caixa
                        </ng-template>
                        <mat-card>
                            <!-- //inicio da tabela -->                                                 
                                        <table mat-table [dataSource]="boxs" class="full-width">
                                            <!-- Coluna ID -->
                                            <ng-container matColumnDef="id">
                                                <th mat-header-cell *matHeaderCellDef> ID </th>
                                                <td mat-cell *matCellDef="let box"> {{ box.id }} </td>
                                            </ng-container>

                                            <!-- Coluna Nome -->
                                            <ng-container matColumnDef="name">
                                                <th mat-header-cell *matHeaderCellDef> nome </th>
                                                <td mat-cell *matCellDef="let box"> {{ box.name  }} </td>
                                            </ng-container>
                                        
                                            <ng-container matColumnDef="pixBalance">
                                                <th mat-header-cell *matHeaderCellDef> saldo Pix </th>
                                                <td mat-cell *matCellDef="let box"> {{ box.pixBalance | currency:'BRL' }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="caixaBalance">
                                                <th mat-header-cell *matHeaderCellDef> saldo Caixa </th>
                                                <td mat-cell *matCellDef="let box"> {{ box.caixaBalance | currency:'BRL' }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="cartaoBalance">
                                                <th mat-header-cell *matHeaderCellDef> saldo Cartao </th>
                                                <td mat-cell *matCellDef="let box"> {{ box.cartaoBalance | currency:'BRL' }} </td>
                                            </ng-container>


                                            <ng-container matColumnDef="excluir">
                                                <th mat-header-cell *matHeaderCellDef> Excluir </th>
                                                <td mat-cell *matCellDef="let box">
                                                    <button (click)="openDialog(box.id)" mat-icon-button color="warn">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="editar">
                                                <th mat-header-cell *matHeaderCellDef>Editar</th>
                                                <td mat-cell *matCellDef="let box">
                                                    <button (click)="editar(box.id)" (click)="tabGroup.selectedIndex = 0"
                                                        mat-icon-button color="accent">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </td>
                                                <ng-container matColumnDef="active">
                                                    <th mat-header-cell *matHeaderCellDef>Status</th>
                                                    <td mat-cell *matCellDef="let box">
                                                        <div *ngIf="box.active==true; else elseBlock">
                                                            <p class="text-primary">Ativo</p>
                                                        </div>
                                                        <ng-template #elseBlock>
                                                            <p class="text-danger">Inativo</p>
                                                        </ng-template>
                                                    </td>
                                                </ng-container>
                                            </ng-container>
                                            <!-- definir como vai ser as linhas e a ordem das colunas -->
                                            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
                                            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                                        </table>

                                        <!-- paginação -->
                                        <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
                                        [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
                                        <!-- evento de paginar -->
                                            </mat-paginator>
                                </mat-card>
                         </mat-tab>
               <!-- LISTANDO TODAS FIM -->
           </mat-tab-group>
       </mat-card>
   </div>
</div>

</main>